import React, { useState, useEffect } from "react";
import {
  localWeatherDummy,
  futureWeathersDummy,
  weatherReportDummy,
  warningSummaryDummy,
  warningInfoDummy,
  weatherTipsDummy,
} from "../services/dummy_data";
import { Card, CardContent, Typography } from "@mui/material";
import WeatherData from "../services/shared_weather";

const WeatherInfo = ({ setIcons, setWarningIcons }) => {
  const [localWeather, setLocalWeather] = useState(localWeatherDummy);
  // const [weatherReport, setWeatherReport] = useState(weatherReportDummy);
  // const [warningSummary, setWarningSummary] = useState(warningSummaryDummy);

  useEffect(() => {
    (async () => {
      const weather = await WeatherData.weather;
      setLocalWeather(weather.localWeather);
      // setWeatherReport(weather.weatherReport);
      // setWarningSummary(weather.warningSummary);
    })();
  }, []);

  return (
    <>
      {/* <div style={{ width: "100%", overflow: "auto", display: "flex" }}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map(() => (
          <div style={{ height: "100px", width: "514px", margin: "16px" }}>
            <Paper style={{ height: "100%", width: "514px" }}>Hello</Paper>
          </div>
        ))}
      </div> */}
      {/* icon:52 */}
      {/* <Draggable> */}
      {/* <Card sx={{ position: "absolute", minWidth: 100 }}> */}
      <Card>
        <CardContent>
          <Typography>{localWeather.forecastDesc ?? "N/A"}</Typography>
          <Typography>{localWeather.generalSituation ?? "N/A"}</Typography>
          <Typography>{localWeather.outlook ?? "N/A"}</Typography>
        </CardContent>
      </Card>
      {/* </Draggable> */}
    </>
  );
};

const f = () => {};

export { WeatherInfo, f };
